<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container-fluid">
    <Breadcrumbs main="Participants" :path="breadcrumbPath" />
    <el-row class="m-0 width-100-p mt-3">
      <el-col class="d-flex align-item-center px-2" :span="24">
        <div class="row m-0 width-100-p px-2">
          <div
            class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
          >
            <el-row :gutter="$vuetify.display.width > 1200 ? 20 : 0">
              <!-- search bay -->
              <el-col
                    :span="$vuetify.display.width > 1200 ? 16 : 24"
                    :class="$vuetify.display.width > 1200 ? 'x-start order-1 mb-10' : 'x-start order-3 mb-10'"
                  >
                    <el-input
                      size="large"
                      v-model="search"
                        :placeholder="selectedSearchBy != '' ? 'Search by ' + (convertLabel(selectedSearchBy)) : 'Choose a search by options' "
                        :prefix-icon="Search"
                        class="mixedSearchBar"
                        id="mixedSearchBar-input"
                        clearable
                        @clear="handleReload"
                    >
                      <template #prepend>

                        <!-- search_by select -->
                        <el-tooltip
                          effect="light"
                          placement="top"
                          show-after="500"
                          hide-after="300"
                          >
                          <template #content > 
                              <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Select Search by" }} </span>
                          </template>

                          <el-select
                            v-model="selectedSearchBy"
                            placeholder="Select"
                            style="min-width: 117px; height: 40px;"
                            @change="handleSelectSearchBy"
                            class="mixedSearchBar-select"
                          >
                            <!-- <template #label>
                              <span>Search by: </span>
                              <span style="font-weight: bold">{{ convertLabel(searchBytabs) }}</span>
                            </template> -->
                            <el-option
                              v-for="(item, index) in search_by_dropdown['selectedTableTab']"
                              :key="index"
                              :label="convertLabel(item)"
                              :value="item"
                            />
                          </el-select>
                        </el-tooltip>
                      </template>
                      
                      <template #append>
                        <!-- <el-button :icon="Search" /> -->
                        <el-button
                            @click.stop="handleReload"
                            class="newSearchButtonClass"
                          >
                          <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                        </el-button>
                      </template>
                    </el-input>

              </el-col>

              <!-- export button -->
              <el-col
                    :class="$vuetify.display.width > 1200 ? 'd-flex justify-content-end order-2' : 'd-flex justify-content-end order-1 mb-20'"
                    :span="$vuetify.display.width > 1200 ? 8 : 24"
                  >
                  <el-button
                      v-if="
                          $store.state.auth.user != null &&
                          !$store.state.auth.user.is_auditor
                        "
                      @click.stop="handleNew"
                      class="newAddButtonNoText new-button-behavior x-end"
                      size="small"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newAddButtonNoText"></use>
                        </svg>
                    </el-button>
                    <el-button
                      @click.stop="handleExportFile"
                      class="new-download-file-btn new-button-behavior x-end"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                        </svg>
                    </el-button>
              </el-col>
            </el-row>

            <DataTable
              :loadingProp="loading"
              :usersDataProp="filter_participant"
              :totalRowProp="total_items"
              @tableAction="handleTableAction"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <ShowDetail
      :open_modal="show_modal"
      :data_modal="data_modal"
      @close_modal="close_modal"
      @confirm_modal="confirm_modal"
    />
  </div>
</template>

<script>
import Breadcrumbs from "../../components/bread_crumbs.vue";
// import XLSX from "xlsx";
import { exportToExcel } from "../dashboard/common/exportExcel";
import UserService from "../../services/user.service";
import DataTable from "./dataTable.vue";

// import Filter from "./filter.vue";
import ShowDetail from "./dialogDetail.vue";
import { ElMessageBox } from "element-plus";
import { convertToTitleCase } from "../dashboard/common/common-tools";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "participants",
  components: {
    Breadcrumbs,
    // Filter,
    ShowDetail,
    DataTable,
  },
  data() {
    return {
      breadcrumbPath: [
        {
          title: "Input",
          disabled: true,
          href: "",
        },
        {
          title: "Participants",
          disabled: false,
          href: "/participants",
          active: true,
        },
      ],

      show: true,
      participantDataList: [],

      search_by_dropdown: 
        {
          selectedTableTab: [
            'duid',
            'gensetid',
            'station_name',
            'participant',
            'region',
            'dispatch_type',
            'fuel_source_primary',
            'technology_type_descriptor',
          ],
        },

      selectedSearchBy: 'duid',
      search: "",

      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,
    };
  },
  watch: {
    // current_page: function (newVal) {
    //   this.fetchParticipantData(newVal);
    // },
  },
  computed: {
    filter_participant() {
      let list = this.participantDataList;
      // let list = this.participantDataList.filter((item) => {
      //   return (
      //     (item.duid === undefined ? "" : item.duid)
      //       .toLowerCase()
      //       .indexOf(this.search.toLowerCase()) > -1 ||
      //     (item.gensetid === undefined ? "" : item.gensetid)
      //       .toLowerCase()
      //       .indexOf(this.search.toLowerCase()) > -1 ||
      //     (item.station_name === undefined ? "" : item.station_name)
      //       .toLowerCase()
      //       .indexOf(this.search.toLowerCase()) > -1 ||
      //     (item.participant === undefined ? "" : item.participant)
      //       .toLowerCase()
      //       .indexOf(this.search.toLowerCase()) > -1 ||
      //     (item.region === undefined ? "" : item.region)
      //       .toLowerCase()
      //       .indexOf(this.search.toLowerCase()) > -1 ||
      //     (item.dispatch_type === undefined ? "" : item.dispatch_type)
      //       .toLowerCase()
      //       .indexOf(this.search.toLowerCase()) > -1 ||
      //     (item.dispatch_type === undefined ? "" : item.dispatch_type)
      //       .toLowerCase()
      //       .indexOf(this.search.toLowerCase()) > -1 ||
      //     (item.fuel_source_primary === undefined
      //       ? ""
      //       : item.fuel_source_primary
      //     )
      //       .toLowerCase()
      //       .indexOf(this.search.toLowerCase()) > -1 ||
      //     (item.technology_type_descriptor === undefined
      //       ? ""
      //       : item.technology_type_descriptor
      //     )
      //       .toLowerCase()
      //       .indexOf(this.search.toLowerCase()) > -1
      //   );
      // });
      //// eslint-disable-next-line vue/no-side-effects-in-computed-properties
      ////this.total_items = list.length;
      //// let paginated = this.paginate(list, this.page_size, this.current_page);
      return list;
    },
  },
  mounted() {
    this.fetchParticipantData(this.current_page, this.search);
  },
  methods: {
    convertLabel(str) {
      return convertToTitleCase(str);
    },

    handleSelectSearchBy(search_by){
      this.selectedSearchBy = search_by;
    },

    changePage(page) {
      console.log(page);
      this.fetchParticipantData(page, this.search);
    },
    fetchParticipantData(page, search) {
      UserService.getParticipants(page, search, this.perPageCount, this.selectedSearchBy)
        .then(
          (response) => {
            //console.log(typeof response.data);
            this.total_items = response.data.total_record;
            this.participantDataList = response.data.participants;
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    DeleteParticipant(user, index) {
      UserService.deleteParticipant(user.id)
        .then(
          // eslint-disable-next-line no-unused-vars
          (response) => {
            this.participantDataList.splice(index, 1);
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    // eslint-disable-next-line no-unused-vars
    handleRowClick(row, column, event) {
      // console.log(row, column, event);
    },
    // eslint-disable-next-line no-unused-vars
    close_modal(event) {
      this.show_modal = false;
    },

    confirm_modal(event) {
      if (this.participantDataList.length == this.current_row_index)
        this.participantDataList.push(event);
      else this.participantDataList[this.current_row_index] = event;
      this.show_modal = false;
    },

    handleShow(index, data) {
      this.current_row_index = index;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },

    // handleExportFile() {
    //   if (this.filter_participant.length > 0) {
    //     const myHeader = [
    //       "country",
    //       "dispatch_int",
    //       "charger_type",
    //       "fuel_emission_intensity",
    //       "afec",
    //       "mpg",
    //       "charger_efficiency",
    //       "tech_improvement_rate",
    //       "fuel_energy_density_MJ_gal",
    //       "fuel_energy_density_MJ_kWh",
    //     ];
    //     const ws = XLSX.utils.json_to_sheet(this.filter_participant, {
    //       header: myHeader,
    //     });
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Data");
    //     XLSX.writeFileXLSX(wb, "ParticipantList.xlsx");
    //   }
    // },

    async handleExportFile() {
      await UserService.getParticipants(1, "", this.perPageCount, this.selectedSearchBy, true).then(
        async (response) => {
        let dataList = response.data.participants;
        
        if (dataList.length > 0) {
          const skipKeys = ["created_at", "updated_at"]; // Keys to skip
          const fileName = "ParticipantList.xlsx"; // File name
          const newWorksheetName = "Participant List"; // Worksheet name
          const title = "Participant List"; // Title for the Excel file

          try {

          
          await exportToExcel({
            dataList,
            skipKeys,
            fileName,
            newWorksheetName,
            title,
          });
        } catch (err) {
          console.log("error when export excel", err.message);
          
        }
          } else {
            console.log("empty data list");
          }
      })

    },

    reset_filter(event) {
      this.current_page = 1;
      this.search = "";
      this.filter = event.filter;
    },

    handleTableAction(event) {
      if (event.kind == "edit") {
        this.handleShow(event.index, event.data);
      } else if (event.kind == "delete") {
        this.deleteRow(event.data, event.index);
      } else if (event.kind == "changePage") {
        this.current_page = event.index;
        this.fetchParticipantData(this.current_page, this.search);
      } else if (event.kind == "perPageChange") {
        this.current_page = 1;
        this.perPageCount = event.index;
        this.handleReload();
      }
    },
    handleReload() {
      this.fetchParticipantData(this.current_page, this.search);
    },
    handleNew() {
      let data = {
        first_name: "",
        last_name: "",
        email: "",
        is_staff: false,
        is_superuser: false,
        is_active: true,
        participant_id: null,
        id: 0,
      };
      this.current_row_index = this.participantDataList.length;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },
    filterSearch(event) {
      this.search = event.search;
      this.fetchParticipantData(1, this.search);
    },

    deleteRow(event, index) {
      console.log(event, index);
      ElMessageBox.confirm("Are you sure to delete this?", "info", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "Confirm Delete",
      })
        .then(() => {
          this.DeleteParticipant(event, index);
          // ElMessage({
          //   type: "success",
          //   message: "Delete completed",
          // });
        })
        .catch(() => {
          // ElMessage({
          //   type: "info",
          //   message: "Delete canceled",
          // });
        });
    },
  },
};
</script>

<style>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-8);
}
.el-table .error-row {
  --el-table-tr-bg-color: var(--el-color-error-light-8);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.cell {
  text-align: center !important;
}

.starter-main .card-body ul {
  list-style-type: none !important;
}

.el-pager {
  -webkit-user-select: none !important;
  user-select: none !important;
  list-style: none !important;
  font-size: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
}

.el-upload-list {
  margin: 10px 0 0 !important;
  padding: 0 !important;
  list-style: none !important;
  position: relative !important;
}
</style>
